import React, { useEffect, useState } from 'react';
import axios from '../../../api/axios';
import { toast } from 'react-toastify';
import { getSiteAdminTemplateCategoriesRoute } from '../../../api/routes';
import { ReactComponent as PencilIcon } from '../../../assets/icons/Pencil.svg';
import config from '../../../config';
import '../SiteAdmin.scss';

const toDisplayUrl = (url) =>
    url && url.startsWith('/files/') ? `${config.apiBaseUrl}${url}` : (url || '');

// ── Category row ───────────────────────────────────────────────────────────────

const CategoryRow = ({ category, onEdit }) => (
    <div className="template-manager-row">
        <div
            className="tm-thumb"
            style={
                category.categoryImage
                    ? { backgroundImage: `url(${toDisplayUrl(category.categoryImage)})` }
                    : {}
            }
        />
        <div className="tm-info">
            <div className="tm-name">{category.name}</div>
            <div className="tm-type">
                <span
                    className={`tcm-status-badge${category.isActive ? ' active' : ' inactive'}`}
                >
                    {category.isActive ? 'Active' : 'Inactive'}
                </span>
            </div>
        </div>
        <div className="tm-desc">
            <span className="tm-desc-text">{category.description || ''}</span>
        </div>
        <div className="tm-edit-icon" onClick={() => onEdit(category)} title="Edit category">
            <PencilIcon className="tm-pencil" aria-label="Edit" />
        </div>
    </div>
);

// ── Main TemplateCategoryManager ───────────────────────────────────────────────

const TemplateCategoryManager = ({ onEdit, onCreate, categoryPatch }) => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');

    useEffect(() => {
        if (categoryPatch) {
            setCategories(prev =>
                prev.map(c => c.id === categoryPatch.id ? { ...c, ...categoryPatch } : c)
            );
        }
    }, [categoryPatch]);

    useEffect(() => {
        axios.get(getSiteAdminTemplateCategoriesRoute, { withCredentials: true })
            .then(res => {
                if (res.data.success) setCategories(res.data.categories);
            })
            .catch(() => toast.error('Failed to load template categories'))
            .finally(() => setLoading(false));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const filtered = search
        ? categories.filter(c =>
            c.name?.toLowerCase().includes(search.toLowerCase()) ||
            c.description?.toLowerCase().includes(search.toLowerCase())
          )
        : categories;

    if (loading) return <div className="home-loading-placeholder" />;

    return (
        <div>
            {onCreate && (
                <div style={{ marginBottom: '1rem', width: '180px' }}>
                    <div className="standard-button button-active" onClick={onCreate}>
                        + Create Category
                    </div>
                </div>
            )}
            <div style={{ marginBottom: '2rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <input
                    className="sa-text-input"
                    style={{ maxWidth: '320px' }}
                    placeholder="Search categories…"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
                <span style={{ fontSize: '0.8rem', color: 'var(--label-color)' }}>
                    {filtered.length} categor{filtered.length !== 1 ? 'ies' : 'y'}
                </span>
            </div>

            <div className="template-manager-grid">
                {filtered.map(c => (
                    <CategoryRow key={c.id} category={c} onEdit={onEdit} />
                ))}
                {filtered.length === 0 && (
                    <p style={{ color: 'var(--label-color)', fontSize: '0.85rem' }}>
                        No categories found.
                    </p>
                )}
            </div>
        </div>
    );
};

export default TemplateCategoryManager;
